/* eslint-disable no-undef */
import { useEffect, useState } from 'react'

const WindowSize = () => {
  const isClient = typeof window === 'object'
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    if (!isClient) {
      return false
    }

    function getSize() {
      return {
        width: isClient ? window.innerWidth : 0,
        height: isClient ? window.innerHeight : 0,
      }
    }

    function handleResize() {
      setWindowSize(getSize())
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    // Cleanup callback to be run after hook is unmounted
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isClient])

  return windowSize
}

export default WindowSize
